import { useState } from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import AccessList from '@/frontend/features/LocalMcp/AccessList'
import CredentialForm from '@/frontend/features/LocalMcp/CredentialForm'
import type { LocalMcpProps } from '@/frontend/features/LocalMcp/types'

export default function CredentialsPanel(props: LocalMcpProps) {
  const [creating, setCreating] = useState(!props.issued_token && props.total_connections === 0)
  const [submitting, setSubmitting] = useState(false)
  const showForm = creating || !!props.editing_access
  return <div className="space-y-7">
    {!showForm && <div className="flex justify-end">
      <Button size="sm" onClick={() => setCreating(true)} disabled={!props.authorization_options.engineering_enabled}><Plus className="size-4" />{props.copy.new_connection}</Button>
    </div>}
    {showForm && <CredentialForm key={props.editing_access ? `${props.editing_access.id}:${props.editing_access.lock_version}` : 'new'} {...props}
      onCancel={() => setCreating(false)} onCreated={() => setCreating(false)} onProcessingChange={setSubmitting} />}
    <AccessList accesses={props.accesses} copy={props.copy} pagination={props.pagination} filters={props.filters}
      total_connections={props.total_connections} editing_access={props.editing_access} formProcessing={submitting} />
  </div>
}
